import * as core from '../../../../../../../core'

import { query } from './edit-subrecipients.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subrecipients.widgets.edit-subrecipients',
    description: 'Edit Subrecipient',
    name: 'Edit Subrecipient',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
